import React from 'react';
import SocialIcons from '../pages/SocialIcons';
import Lottie from 'lottie-react';
import whatsappAnimation from '../assets/whatsapp.json';
import "../Header.css";
import "../Hero.css";
import { MdEmail, MdPhone, MdLocationOn } from "react-icons/md";
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-black text-gray-200 px-4 md:px-8 py-10 font-inter">
      {/* Outer Centered Wrapper */}
      <div className="w-full flex justify-center">
        <div className="w-full max-w-screen-xl grid grid-cols-1 lg:grid-cols-3 gap-x-8 gap-y-10 text-center lg:text-left">

          {/* Logo & Description */}
          <div className="text-center lg:text-left">
            <div className="w-full flex justify-center lg:justify-start">
              <div className="text-2xl font-bold max-w-[200px] w-full">
                <svg viewBox="0 0 500 100" className="w-full lavanya-svg">
                  <symbol id="s-text">
                    <text textAnchor="middle" x="50%" y="50%" dy=".35em">
                      Lavanya infotech
                    </text>
                  </symbol>
                  {[...Array(5)].map((_, i) => (
                    <use key={i} className="lavanya-text" href="#s-text" />
                  ))}
                </svg>
              </div>
            </div>
            <p className="text-sm mt-2">
              “Innovate, Transform, Succeed – Lavanya Info Tech, your partner in digital excellence.”
            </p>
            <div className="flex justify-center lg:justify-start space-x-4 mt-4">
              <SocialIcons />
            </div>
          </div>

          {/* Navigation + Services (2 Columns on All Screens) */}
          <div className="grid grid-cols-2 gap-8 w-full text-center lg:text-left">
            {/* Navigation */}
            <div>
              <h3 className="text-lg font-semibold mb-4 font-poppins">Navigation</h3>
              <ul className="space-y-2 text-sm">
                <li><Link to="/" className="hover:text-[#f19c79]">Home</Link></li>
                <li><Link to="/services" className="hover:text-[#f19c79]">Services</Link></li>
                <li><Link to="/career" className="hover:text-[#f19c79]">Career</Link></li>
                <li><Link to="/about" className="hover:text-[#f19c79]">About Us</Link></li>
                <li><Link to="/portfolio" className="hover:text-[#f19c79]">Portfolio</Link></li>
                <li><Link to="/faq" className="hover:text-[#f19c79]">FAQ</Link></li>
                <li><Link to="/contact" className="hover:text-[#f19c79]">Contact</Link></li>
              </ul>
            </div>

            {/* Services */}
            <div>
              <h3 className="text-lg font-semibold mb-4 font-poppins">Services</h3>
              <ul className="space-y-2 text-sm">
                <li><Link to="/services" className="hover:text-[#f19c79]">Web Development</Link></li>
                <li><Link to="/services" className="hover:text-[#f19c79]">App Development</Link></li>
                <li><Link to="/services" className="hover:text-[#f19c79]">Graphics Design</Link></li>
                <li><Link to="/services" className="hover:text-[#f19c79]">Digital Marketing</Link></li>
              </ul>
            </div>
          </div>

          {/* Contact */}
          <div className="text-center lg:text-left">
            <h3 className="text-lg font-semibold mb-4 font-poppins">Contact Details</h3>
            <ul className="space-y-4 text-sm">
              <li className="flex flex-col lg:flex-row items-center lg:items-start gap-1">
                <MdEmail className="text-2xl text-[#00E1FF]" />
                <span> infotech.lavanya.18@gmail.com</span>
              </li>
              <li className="flex flex-col  lg:flex-row items-center lg:items-start gap-1">
                <MdPhone className="text-2xl text-green-400" />
                <span>+91 87585 76361</span>
              </li>
              <li className="flex flex-col lg:flex-row items-center lg:items-start gap-1">
                <MdLocationOn className="text-3xl text-red-400" />
                <span className="max-w-xs">
                  75, First Floor Meera Nagar Soc., Ak Road, Mini Bazar, Varachha, Surat. Pincode-395006
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>



      {/* Footer Bottom */}
      <div className="mt-8 text-center text-xs border-t border-gray-700 pt-4">
        ©2025. Lavanya Info Tech. All Rights Reserved.
      </div>

      {/* Floating Buttons */}
      <div className="fixed bottom-4 right-4 z-50 flex flex-col lg:items-end space-y-3">
        {/* WhatsApp Button */}
        <a
          href="https://wa.me/918758576361"
          target="_blank"
          rel="noreferrer"
          className="bg-green-500 rounded-full shadow-md w-12 h-12 flex items-center justify-center"
        >
          <Lottie
            animationData={whatsappAnimation}
            loop={true}
            style={{ width: "32px", height: "32px" }}
          />
        </a>

        {/* Scroll-to-Top Button */}
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="bg-indigo-600 rounded-full shadow-md w-12 h-12 flex items-center justify-center"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-5 h-5 text-white"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M3.293 9.707a1 1 0 011.414 0L10 4.414l5.293 5.293a1 1 0 001.414-1.414l-6-6a1 1 0 00-1.414 0l-6 6a1 1 0 010 1.414z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </div>

    </footer>
  );
};

export default Footer;
